/** Minúsculas e sem acento: "Grão" casa com "grao" e "Marina" com "marína". */
export function normalizeText(text: string) {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/**
 * Busca em vários campos de uma vez (empresa e contratante, por exemplo). Cada palavra digitada precisa aparecer em
 * algum dos campos, em qualquer ordem, então "marina cafe" acha o Café Grão Dourado da Marina. Busca vazia casa com tudo.
 */
export function matchesSearch(query: string, ...fields: (string | null | undefined)[]) {
  const words = normalizeText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = normalizeText(fields.filter(Boolean).join(' '));
  return words.every((word) => haystack.includes(word));
}
